export const SUBMENU_CONTENT_ANIMATION_CLASS_NAME = [
    // The active side is chosen by Radix after collision detection.
    'data-[side=right]:data-[state=open]:animate-slideRightAndFadeIn',
    'data-[side=right]:data-[state=closed]:animate-slideLeftAndFadeOut',
    'data-[side=left]:data-[state=open]:animate-slideLeftAndFadeIn',
    'data-[side=left]:data-[state=closed]:animate-slideRightAndFadeOut',
    'data-[side=bottom]:data-[state=open]:animate-slideDownAndFadeIn',
    'data-[side=bottom]:data-[state=closed]:animate-slideUpAndFadeOut',
    'data-[side=top]:data-[state=open]:animate-slideUpAndFadeIn',
    'data-[side=top]:data-[state=closed]:animate-slideDownAndFadeOut',
].join(' ');
//# sourceMappingURL=MenuSubmenuContentClassName.js.map